import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import TableSettingsDrawerContent, {
  TableSettingsDrawerProps,
} from "ds/components/Table/Settings/DrawerContent";

import { TableSimpleStore } from "./types";

type TableSimpleSettingsDrawerProps = {
  store: TableSimpleStore;
} & Pick<TableSettingsDrawerProps, "trackAnalytics">;

const TableSimpleSettingsDrawer = createDrawer(
  ({ store, trackAnalytics }: TableSimpleSettingsDrawerProps) => {
    return <TableSettingsDrawerContent store={store} trackAnalytics={trackAnalytics} />;
  }
);

export const showTableSimpleSettingsDrawer = createDrawerTrigger(TableSimpleSettingsDrawer);
